export const actionTypes = {
    SET_SELECTED_ASSET: 'crossAssetAnalysisV2/SET_SELECTED_ASSET',
    GET_KPIS_FOR_KPI_TYPE: 'crossAssetAnalysisV2/GET_KPIS_FOR_KPI_TYPE',
    GET_ASSET_CAPABILITY: 'crossAssetAnalysisV2/GET_ASSET_CAPABILITY',
    GET_ASSET_SUBSCRIPTION: 'crossAssetAnalysisV2/GET_ASSET_SUBSCRIPTION',
    GET_POWERTRAIN_LIST_FOR_BROWSER: 'crossAssetAnalysisV2/GET_POWERTRAIN_LIST_FOR_BROWSER',
    SET_BROWSER_CATEGORY: 'crossAssetAnalysisV2/SET_BROWSER_CATEGORY',
    SET_SELECTED_POWERTRAIN_ID: 'crossAssetAnalysisV2/SET_SELECTED_POWERTRAIN_ID',
    CLEAR_KPI_LIST: 'crossAssetAnalysisV2/CLEAR_KPI_LIST',
    ADD_OFF_GRAPH_SIGNAL: 'crossAssetAnalysisV2/ADD_OFF_GRAPH_SIGNAL',
    REMOVE_OFF_GRAPH_SIGNAL: 'crossAssetAnalysisV2/REMOVE_OFF_GRAPH_SIGNAL',
    CLEAR_OFF_GRAPH_SIGNALS: 'crossAssetAnalysisV2/CLEAR_OFF_GRAPH_SIGNALS',
    CLEAR_STORE: 'crossAssetAnalysisV2/CLEAR_STORE',
    // Resets store but preserves offGraphSignals so the user sees previous signals on return
    ON_GRAPH_CLEAR_STORE: 'crossAssetAnalysisV2/ON_GRAPH_CLEAR_STORE',
    // Dispatched by GeneralFilterModal on org/site/asset-group change — the previous org's asset/KPI selection is no longer valid
    SET_SELECTED_FILTERS: 'generalFilter/SET_SELECTED_FILTERS'
};

export const browserCategories = {
    POWERTRAINS: 'Powertrains',
    ASSETS: 'Assets'
};

export const scatterHistogramAssistCardTypes = {
    ADD: 'add',
    ALREADY_ADDED: 'already_added',
    CANT_JOIN: 'cant_join'
};
